import accountReceivables from "./accountReceivables";

const accountStatementService = [
    {
        matcher: 'accountReceivables',
        reply: config => {
            return [200, accountReceivables];
        }
    },
    {
        matcher: /accountReceivables\/(.*)/,
        reply: config => {
            const id = /accountReceivables\/(.*)/.exec(config.url)[1];
            const data = accountReceivables.find(item => item.uuid === id);
            return [200, data];
        }
    },
]

export default accountStatementService;